import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { BaseActionData } from './base-action-data';

/**
 * Représente les données d'une action 'Clos une étape'.
 */
export class CompleteStepActionData extends BaseActionData {
    /**
     * Id de l'étape à completer.
     */
    public stepId: number;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.CompleteStep);
    }

    /**
     * Retourne une copie d'une instance de CompleteStepActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: CompleteStepActionData) {
        if (!!other) {
            const instance = new CompleteStepActionData();
            instance.stepId = other.stepId;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
